import { useState, useEffect } from 'react'
import { useNavigate, NavLink } from 'react-router-dom'
import { Circle, ExpandLess, ExpandMore } from '@mui/icons-material'

import {
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
  MenuItem,
  MenuList,
} from '@mui/material'
import { SidebarId } from '@/enums/sidebar-id.enum'
import { SidebarLinkType } from '../../hooks/use-sidebar-links.hook'

import useStyles from '../../style'
import useSidebarUI from '../../hooks/use-sidebar-ui.hook'

type Props = {
  link: SidebarLinkType
  sidebarStatus: boolean
  sidebarIds: SidebarId[]
  handleSidebarOpen: () => void
}

const MenuLinkComponent = ({
  link,
  sidebarStatus,
  sidebarIds,
  handleSidebarOpen,
}: Props) => {
  const navigate = useNavigate()

  const { classes } = useStyles()

  const { isCurrentPage } = useSidebarUI()

  const isCurrentParent =
    link.links && link.links.some((item) => isCurrentPage(item.route))

  const [openDropdown, setOpenDropdown] = useState(false)

  const handleClickDropdown = () => {
    if (link.links && link.links.length > 0) {
      setOpenDropdown(!openDropdown)
      handleSidebarOpen()
    } else {
      navigate(link.route)
    }
  }

  useEffect(() => {
    if (!sidebarStatus) {
      setOpenDropdown(false)
    }
  }, [sidebarStatus])

  return (
    <>
      {link.title && (
        <Typography className="menuTitle">{link.title}</Typography>
      )}
      <MenuItem
        disableGutters
        onClick={(event) => {
          event.preventDefault()
          handleClickDropdown()
        }}
        title={link.labelText}
        className={`${classes.link} ${
          isCurrentPage(link.route) ? 'active' : isCurrentParent ? 'active' : ''
        }`}
        sx={{ cursor: 'pointer' }}
      >
        <ListItemIcon>{link.labelIcon}</ListItemIcon>
        <ListItemText primary={link.labelText} />
        {link.links && <>{openDropdown ? <ExpandLess /> : <ExpandMore />}</>}
      </MenuItem>
      {link.links && link.links.length > 0 && (
        <Collapse in={openDropdown} timeout="auto" unmountOnExit>
          <MenuList disablePadding>
            {link.links &&
              link.links
                .filter(
                  (item) =>
                    sidebarIds.includes(item.id) && item.visible === true,
                )
                .map((item) => (
                  <MenuItem
                    key={item.id}
                    component={NavLink}
                    to={item.route}
                    title={item.labelText}
                    className={classes.linkInner}
                    end
                  >
                    <ListItemIcon>
                      <Circle />
                    </ListItemIcon>
                    <ListItemText inset primary={item.labelText} />
                  </MenuItem>
                ))}
          </MenuList>
        </Collapse>
      )}
    </>
  )
}

export default MenuLinkComponent
